import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface RectangleStackProps extends IconProps {
  color?: TIconColor;
}

const RectangleStack = ({ size, variant, className, color = 'navy' }: RectangleStackProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      d="M3.71094 3.10482C3.96234 3.03648 4.22686 3 4.49991 3H11.4999C11.773 3 12.0375 3.03648 12.2889 3.10483C11.9604 2.44969 11.2827 2 10.4999 2H5.49991C4.71714 2 4.0394 2.44969 3.71094 3.10482Z"
      fill="currentColor"
    />
    <path
      d="M1.5 8C1.5 6.89543 2.39543 6 3.5 6H12.5C13.6046 6 14.5 6.89543 14.5 8V12C14.5 13.1046 13.6046 14 12.5 14H3.5C2.39543 14 1.5 13.1046 1.5 12V8Z"
      fill="currentColor"
    />
    <path
      d="M3.49991 5C3.22686 5 2.96234 5.03648 2.71094 5.10482C3.0394 4.44969 3.71714 4 4.49991 4H11.4999C12.2827 4 12.9604 4.44969 13.2889 5.10483C13.0375 5.03648 12.773 5 12.4999 5H3.49991Z"
      fill="currentColor"
    />
  </svg>
);

export default RectangleStack;
